import React from 'react'

import classes from './LoadingSpinner.module.css';


// function LoadingSpinner(props) {
//     return (
//         <div className={css`
//             width: 100%;
//             height: 350px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         `}>
//             <img className={css`
//             display:block;
//             `}
//                 src={loadingSpinner} alt=""></img>
//         </div>
//     )
// }


function LoadingSpinner(props) {
    return (
        <div className={classes.ldsEllipsis}><div></div><div></div><div></div><div></div></div>
    )
}
LoadingSpinner.propTypes = {

}

export default LoadingSpinner

